import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const QuickActionsCard = ({ onAction }) => {
  const quickActions = [
    {
      id: 'find-gift',
      title: 'Find Perfect Gift',
      description: 'Use AI to discover ideal gifts',
      icon: 'Search',
      color: 'primary',
      action: () => onAction('find-gift')
    },
    {
      id: 'create-wishlist',
      title: 'Create Wishlist',
      description: 'Build your personal wishlist',
      icon: 'Heart',
      color: 'secondary',
      action: () => onAction('create-wishlist')
    },
    {
      id: 'add-occasion',
      title: 'Add Occasion',
      description: 'Never miss important dates',
      icon: 'Calendar',
      color: 'accent',
      action: () => onAction('add-occasion')
    },
    {
      id: 'gift-concierge',
      title: 'Gift Concierge',
      description: 'Get expert gift advice',
      icon: 'MessageCircle',
      color: 'success',
      action: () => onAction('gift-concierge')
    }
  ];

  const getColorClasses = (color) => {
    switch (color) {
      case 'primary':
        return 'bg-primary-100 text-primary hover:bg-primary-200';
      case 'secondary':
        return 'bg-secondary-100 text-secondary hover:bg-secondary-200';
      case 'accent':
        return 'bg-accent-100 text-accent-600 hover:bg-accent-200';
      case 'success':
        return 'bg-success-100 text-success-600 hover:bg-success-200';
      default:
        return 'bg-accent-100 text-accent-600 hover:bg-accent-200';
    }
  };

  return (
    <div className="bg-white rounded-2xl p-6 shadow-soft border border-accent-100">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 bg-primary-100 rounded-xl flex items-center justify-center">
          <Icon name="Zap" size={20} className="text-primary" />
        </div>
        <div>
          <h3 className="font-heading text-xl font-semibold text-accent-800">Quick Actions</h3>
          <p className="text-sm text-accent-600">Get things done faster</p>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {quickActions.map((action) => (
          <button
            key={action.id}
            onClick={action.action}
            className={`p-4 rounded-xl text-left transition-all duration-200 hover:shadow-soft ${getColorClasses(action.color)}`}
          >
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 bg-white rounded-lg flex items-center justify-center shadow-soft flex-shrink-0">
                <Icon name={action.icon} size={18} className="text-accent-600" />
              </div>
              <div className="flex-1 min-w-0">
                <h4 className="font-medium text-accent-800 mb-1">{action.title}</h4>
                <p className="text-sm text-accent-600">{action.description}</p>
              </div>
            </div>
          </button>
        ))}
      </div>

      {/* Additional Quick Links */}
      <div className="mt-6 pt-6 border-t border-accent-100">
        <div className="flex flex-wrap gap-2">
          <Button
            variant="ghost"
            size="sm"
            iconName="Settings"
            onClick={() => onAction('settings')}
            className="text-accent-600 hover:text-accent-800"
          >
            Settings
          </Button>
          <Button
            variant="ghost"
            size="sm"
            iconName="HelpCircle"
            onClick={() => onAction('help')}
            className="text-accent-600 hover:text-accent-800"
          >
            Help
          </Button>
          <Button
            variant="ghost"
            size="sm"
            iconName="Download"
            onClick={() => onAction('export')}
            className="text-accent-600 hover:text-accent-800"
          >
            Export Data
          </Button>
        </div>
      </div>
    </div>
  );
};

export default QuickActionsCard;